export default __webpack_public_path__ + "static/media/indiklin_n95_face_mask_with_respirator_pack_of_3_0_1.d2d6d870.dib";